import store from '@/store'
import D2C_Provider from '../Provider'

class D2C_ProviderLogs extends D2C_Provider {
  purpose = 'logs'
  static objectType = 'providerPurpose'
  static purposeName = 'logs'
  static purposeTitle = 'Logs'
  get _services() {
    return store.getters.services.filter(service => service.logProvider === this.id)
  }
}

export default D2C_ProviderLogs
